import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useRecoilValue } from 'recoil';
import { showPoweredBySelector, themeSelector, variantSelector, } from '@/state/config';
import { PoweredBy } from '../PoweredBy/PoweredBy';
import { ToastsWrapper as Toasts } from '../Toast/ToastWrapper';
import styles from './ChatFooter.module.scss';
export const ChatFooter = ({ children }) => {
    const theme = useRecoilValue(themeSelector);
    const showPoweredBy = useRecoilValue(showPoweredBySelector);
    const { isNbg } = useRecoilValue(variantSelector);
    return (_jsxs("div", { className: cn(styles.container, styles[theme], {
            [styles.hidePoweredBy]: !showPoweredBy,
            [styles.isNbg]: isNbg,
        }), children: [_jsx(Toasts, {}), children, showPoweredBy && (_jsx("span", { className: styles.poweredBy, children: _jsx(PoweredBy, {}) }))] }));
};
